import FalconCloseButton from "components/common/FalconCloseButton";
import { useToast } from "context/providers/ToastProvider";
import useToken from "hooks/useToken";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";

const ModalActualizarDatosFiscalesCliente = ({
    setShowModalActualizarDatos,
    showModalActualizarDatos,
    objDatosFiscales,
    setObjDatosFiscales,
    idSource, //Esta variable indica de donde se abre este Modal : 1 - Desde Nueva Orden, 2 - Desde Detalles de Orden
    GuardarComentario,
    onComentarioAgregado,
}) => {
    const [procesandoModal, setProcesandoModal] = useState(false);
    const { token, setToken, nombreCompleto } = useToken();
    const [tablaRegimenFiscal, settablaRegimenFiscal] = useState([]);
    const [tablaUsoCFDI, settablaUsoCFDI] = useState([]);
    const [paises, setPaises] = useState([]);
    const { register, setValue, reset, handleSubmit, formState: { errors } } = useForm();
    const [cargando, setCargando] = useState(true);
    const { showErrorToast, showSuccessToast } = useToast();
    const [isForeign, setIsForeign] = useState(false);
    /**
     * Actuqalizar datos fiscales
     * @param {any} values
     */

    const onSubmit = (data) => {
        let rfc = (data.vRfc).trim();
        //validaciones sewgun el RFC generico (nacional o extranjero)
        if (rfc === "XEXX010101000" || rfc === "XAXX010101000") {
            if (data.vCp != '61770') {
                showErrorToast("El código postal debe ser 61770 para RFC genéricos.");
                return;
            }
               
            if (data.idCatUsoCFDI != 22) {
                showErrorToast("El uso de CFDI del RFC genérico debe ser: Sin efectos fiscales.");
                return;
            }
                
            if ( data.idCatRegimenFiscal != 12) {
                showErrorToast("El régimen fiscal del RFC genérico debe ser: Sin Obligaciones Fiscales.");
                return;
            }
        }
        
        if (rfc != "XEXX010101000") {
            data.vPaisFacturacion= "";
            data.vNumRegTrib= "";
        }

        if (idSource == 1)
            actualizarDatosFiscalesCliente(data);
        else
            if (idSource == 2)
                actualizarDatosFiscalesOrden(data);
    }

    /**
     * Actuqalizar datos fiscales
     * @param {any} values
     */
    const actualizarDatosFiscalesOrden = async (values) => {
        console.log(values);

        setProcesandoModal(true);

        const response = await fetch("/api/orden/actualizarDatosFiscales/?id=" + objDatosFiscales.idOrden + "&jsonDatosFiscales=" + encodeURIComponent(JSON.stringify(values)), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                var detalles = JSON.parse(data.detalles);
                console.log("detalles Order Update: ", detalles);
                setObjDatosFiscales({
                    ...objDatosFiscales,
                    vRfc: detalles[0].vRfc,
                    vRazonSocial: detalles[0].vRazonSocial,
                    idCatRegimenFiscal: detalles[0].idCatRegimenFiscal,
                    vNumRegTrib: detalles[0].vNumRegTrib,
                    vDireccionFiscal: detalles[0].vDireccionFiscal,
                    vCp: detalles[0].vCp,
                    idCatUsoCFDI: detalles[0].idCatUsoCFDI,
                    vCodigoUso: detalles[0].vCodigoUso,
                    vDescripcionUsoCFDI: detalles[0].vDescripcionUsoCFDI,
                    vCodigoRegimen: detalles[0].vCodigoRegimen,
                    vDescripcionRegimenFiscal: detalles[0].vDescripcionRegimenFiscal,
                    vEmailFacturacion: detalles[0].vEmailFacturacion,
                    vTelefonoFacturacion: detalles[0].vTelefonoFacturacion,
                    vPaisFacturacion: detalles[0].vPaisFacturacion
                })

                GuardarComentario(objDatosFiscales.idOrden, `<b>${nombreCompleto}</b> actualizó los datos fiscales de la orden`, 2, objDatosFiscales, (comentarioBD) => {
                    onComentarioAgregado(comentarioBD);
                }, (error) => {
                    showErrorToast(error);
                });
            }
            else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActualizarDatos(false);
        setProcesandoModal(false);
    };

    /**
     * Actualizar datos fiscales
     * @param {any} values
     */
    const actualizarDatosFiscalesCliente = async (values) => {
        console.log(values);

        setProcesandoModal(true);

        const response = await fetch("/api/cliente/actualizarDatosFiscales/?id=" + objDatosFiscales.idClienteAkasia + "&jsonDatosFiscales=" + encodeURIComponent(JSON.stringify(values)), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data.iResponseType == 1) {
                showSuccessToast(data.vMessage);

                var detalles = JSON.parse(data.detalles);
                console.log("detalles Cliente Fiscal Data Update: ", detalles);
                setObjDatosFiscales({
                    ...objDatosFiscales,
                    vRfc: detalles[0].vRfc,
                    vRazonSocial: detalles[0].vRazonSocial,
                    idCatRegimenFiscal: detalles[0].idCatRegimenFiscal,
                    vNumRegTrib: detalles[0].vNumRegTrib,
                    vDireccionFiscal: detalles[0].vDireccionFiscal,
                    vCp: detalles[0].vCp,
                    idCatUsoCFDI: detalles[0].idCatUsoCFDI,
                    vCodigoUso: detalles[0].vCodigoUso,
                    vDescripcionUsoCFDI: detalles[0].vDescripcionUsoCFDI,
                    vCodigoRegimen: detalles[0].vCodigoRegimen,
                    vDescripcionRegimenFiscal: detalles[0].vDescripcionRegimenFiscal,
                    vEmailFacturacion: detalles[0].vEmailFacturacion,
                    vTelefonoFacturacion: detalles[0].vTelefonoFacturacion,
                    vPaisFacturacion: detalles[0].vPaisFacturacion
                })
            }
            else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActualizarDatos(false);
        setProcesandoModal(false);
    };

    //OBTENER Lista de Modulos No vinculados
    const ObtenerListaRegimenesFiscales = async () => {
        setCargando(true);
        const response = await fetch("/api/orden/ObtenerListaCatalogosFiscales", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
            setCargando(false);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            settablaRegimenFiscal(data['table1']);
            settablaUsoCFDI(data['table2']);
            setValue("vPaisFacturacion", objDatosFiscales.vPaisFacturacion);
            setCargando(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setCargando(false);
        }
    };

    /**
     * Obtiene los paises del Cat Sat
     */
    const ObtenerCatPaises = async () => {
        const response = await fetch("/api/Facturas/ObtenerCatPaises",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setPaises(ObjDetalles.table2);
            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    useEffect(() => {
        if (objDatosFiscales.vRfc === "XEXX010101000") {
            setIsForeign(true);
        } else {
            setIsForeign(false);
        }
    }, [objDatosFiscales.vRfc]);


    return (
        <Modal
            show={showModalActualizarDatos}
            onHide={() => reset()}
            onShow={() => { ObtenerListaRegimenesFiscales(); ObtenerCatPaises(); }}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>Editar Datos Fiscales </Modal.Title>
                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalActualizarDatos(false); }} />

            </Modal.Header>
            <Modal.Body >
                <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                    {isForeign && (
                        <Alert variant="warning">
                            <Badge bg="warning" text="dark">EXTRANJERO</Badge> Este cliente es extranjero. Asegúrese de completar los campos requeridos para facturación internacional.
                        </Alert>
                    )}
                    <Row>

                        <Col>
                            <Table responsive striped size="sm"  >
                                <tbody>

                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4"><strong>RFC</strong></td>
                                        <td>
                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                defaultValue={objDatosFiscales.vRfc}
                                                isInvalid={!!errors.vRfc}
                                                {...register('vRfc',
                                                    {
                                                        required: 'El RFC es obligatorio',
                                                        maxLength: 13,
                                                        minLength: 12,
                                                        pattern: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/
                                                    })
                                                }
                                                onChange={(event) => {
                                                    let rfc = (event.target.value).trim().toUpperCase();
                                                    if (rfc === "XEXX010101000" || rfc === "XAXX010101000") {
                                                        setValue('vCp', '61770');
                                                        setValue("idCatUsoCFDI", 22);
                                                        setValue("idCatRegimenFiscal", 12);

                                                    }
                                                    if (rfc == "XEXX010101000")
                                                        setIsForeign(true)
                                                    else
                                                        setIsForeign(false);

                                                }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vRfc && errors.vRfc.message}
                                            </Form.Control.Feedback>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4"><strong>Raz&oacute;n Social</strong></td>
                                        <td>

                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                defaultValue={objDatosFiscales.vRazonSocial}
                                                isInvalid={!!errors.vRazonSocial}
                                                {...register('vRazonSocial',
                                                    {
                                                        required: 'La Raz\u00f3n Social es  obligatoria',
                                                        maxLength: 300,
                                                        minLength: 1,
                                                        pattern: /[^|]{1,300}/
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vRazonSocial && errors.vRazonSocial.message}
                                            </Form.Control.Feedback>
                                        </td>
                                    </tr>
                                    
                                    {isForeign &&
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4">
                                                <strong>Num. Reg. Trib.</strong>
                                            </td>
                                            <td>

                                                <Form.Control
                                                    size="sm"
                                                    autoComplete="off"
                                                    type="text"
                                                    onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                    defaultValue={objDatosFiscales.vNumRegTrib}
                                                    isInvalid={!!errors.vNumRegTrib}
                                                    {...register('vNumRegTrib',
                                                        {
                                                            maxLength: 40,
                                                            minLength: 1
                                                        })
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vNumRegTrib && errors.vNumRegTrib.message}
                                                </Form.Control.Feedback>

                                            </td>
                                        </tr>
                                    }
                                    {isForeign &&
                                        <tr>
                                            <td className="col-lg-4 col-sm-4 col-md-4"><strong>País</strong></td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    defaultValue={objDatosFiscales.vPaisFacturacion}
                                                    isInvalid={!!errors.vPaisFacturacion}
                                                    {...register("vPaisFacturacion", { required: 'El país es un dato obligatorio para facturar.' })}
                                                >
                                                    <option value="">Seleccione un País</option>
                                                    {paises.map((pais, index) => (
                                                        <option key={index} value={pais.cShortName}>
                                                            {pais.cShortName} - {pais.vName}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vPaisFacturacion && errors.vPaisFacturacion.message}
                                                </Form.Control.Feedback>
                                            </td>
                                        </tr>
                                    }
                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4">
                                            <strong>Direcci&oacute;n Fiscal</strong>
                                        </td>
                                        <td>

                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                size="sm"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                defaultValue={objDatosFiscales.vDireccionFiscal}
                                                isInvalid={!!errors.vDireccionFiscal}
                                                {...register('vDireccionFiscal',
                                                    {
                                                        required: 'La direccion fiscal es obligatorio',
                                                        maxLength: 300,
                                                        minLength: 10
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vDireccionFiscal && errors.vDireccionFiscal.message}
                                            </Form.Control.Feedback>

                                        </td>
                                    </tr>


                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4">
                                            <strong>C&oacute;digo Postal</strong>
                                        </td>
                                        <td>
                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="number"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                defaultValue={objDatosFiscales.vCp}
                                                isInvalid={!!errors.vCp}
                                                {...register('vCp',
                                                    {
                                                        required: 'El Codigo postal es obligatorio',
                                                        maxLength: 6,
                                                        minLength: 4
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vCp && errors.vCp.message}
                                            </Form.Control.Feedback>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4"><strong>R&eacute;gimen Fiscal</strong></td>
                                        <td>
                                            {!cargando &&
                                                <Form.Select
                                                    size="sm"
                                                    aria-label="Default select"
                                                    defaultValue={objDatosFiscales.idCatRegimenFiscal}
                                                    isInvalid={!!errors.idCatRegimenFiscal}
                                                    {...register("idCatRegimenFiscal",
                                                        {
                                                            required: true
                                                        })
                                                    }
                                                >
                                                    <option value="">Selecciona un r&eacute;gimen</option>
                                                    {tablaRegimenFiscal.map((regimen, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={regimen.idCatRegimenFiscal}>
                                                                {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                                            </option>)
                                                    })}
                                                </Form.Select>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4">
                                            <strong>Uso CFDI</strong>
                                        </td>
                                        <td>
                                            {!cargando &&
                                                <Form.Select
                                                    size="sm"
                                                    aria-label="Default select"
                                                    defaultValue={objDatosFiscales.idCatUsoCFDI}
                                                    isInvalid={!!errors.idCatUsoCFDI}
                                                    {...register("idCatUsoCFDI",
                                                        {
                                                            required: true
                                                        })
                                                    }
                                                >
                                                    <option value="">Selecciona un uso de CFDI</option>
                                                    {tablaUsoCFDI.map((uso, index) => {
                                                        return (
                                                            <option
                                                                key={index}
                                                                value={uso.idCatUsoCFDI}>
                                                                {uso.vCodigoUso} - {uso.vDescripcionUsoCFDI}
                                                            </option>)
                                                    })}
                                                </Form.Select>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4">
                                            <strong>Correo de facturaci&oacute;n</strong>
                                        </td>
                                        <td>

                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                defaultValue={objDatosFiscales.vEmailFacturacion}
                                                isInvalid={!!errors.vEmailFacturacion}
                                                {...register("vEmailFacturacion",
                                                    {
                                                        maxLength: 120,
                                                        minLength: 5,
                                                        pattern: {
                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                            message: "Email incorrecto."
                                                        }
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vEmailFacturacion && errors.vEmailFacturacion.message}
                                            </Form.Control.Feedback>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="col-lg-4 col-sm-4 col-md-4">
                                            <strong>Tel&eacute;fono de facturaci&oacute;n</strong>
                                        </td>
                                        <td>

                                            <Form.Control
                                                size="sm"
                                                autoComplete="off"
                                                type="text"
                                                defaultValue={objDatosFiscales.vTelefonoFacturacion}
                                                isInvalid={!!errors.vTelefonoFacturacion}
                                                {...register("vTelefonoFacturacion",
                                                    {
                                                        required: false,
                                                        maxLength: 20,
                                                        minLength: 5,
                                                        pattern: {
                                                            value: /^[+][0-9]+$/,
                                                            message: "Tel\u00E9fono incorrecto. Debe iniciar con el prefijo: +"
                                                        }
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vTelefonoFacturacion && errors.vTelefonoFacturacion.message}
                                            </Form.Control.Feedback>

                                        </td>
                                    </tr>

                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                    <Modal.Footer>
                        <Button onClick={() => { setShowModalActualizarDatos(false); }} variant='primary' >Cerrar</Button>
                        {procesandoModal ? <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Procesando...
                        </Button> : <Button type="submit" variant='success' >Guardar cambios</Button>}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

ModalActualizarDatosFiscalesCliente.propTypes = {
    setShowModalActualizarDatos: PropTypes.func,
    showModalActualizarDatos: PropTypes.bool,
    objDatosFiscales: PropTypes.object,
    setObjDatosFiscales: PropTypes.func,
    idSource: PropTypes.number,
    GuardarComentario: PropTypes.func,
    onComentarioAgregado: PropTypes.func
};


export default ModalActualizarDatosFiscalesCliente;